export default (embed = {}) => {
  switch (embed.provider_name) {
    case 'YouTube':
      const regex = /\?feature=oembed/
      return regex.test(embed.html) ? embed.html.replace(regex, '?rel=0') : embed.html
    default:
      return embed.html
  }
}



// WEBPACK FOOTER //
// ./lib/embedHtml/index.js